import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../styles/VendorConflictModal.css';

const VendorConflictModal = ({
  show,
  onConfirm,
  onCancel,
  conflictingVendorName = "another vendor"
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      keyboard={false}
      className="vendor-conflict-modal"
    >
      <Modal.Body className="vendor-conflict-body">
        <div className="vendor-conflict-content">
          <h5 className="vendor-conflict-title">⚠️ Different Vendor Detected</h5>
          <p className="vendor-conflict-message">
            Your cart has items from <b>{conflictingVendorName}</b>.<br />
            Do you want to clear your cart and add this item from a new vendor?
          </p>
          <div className="vendor-conflict-actions">
            <Button variant="outline-secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="danger" onClick={onConfirm}>
              Clear & Add
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VendorConflictModal;